import {
    Box,
    Button,
    CircularProgress,
    Snackbar,
    TextField,
    Typography,
  } from "@mui/material";
  import React from "react";
  import { useEffect, useState } from "react";

  import { useNavigate } from "react-router-dom";
  import { baseURL } from "../Config/config";
  
  import { Link } from "@mui/material";
  import Modal from "@mui/material/Modal";
  import { Paper } from "@mui/material";
  import CloseIcon from "@mui/icons-material/Close";
  import Projectcolors from "../Utils/Colors";
  
  import Selexlogo from "../images/de3.png";
  import matrix from "../images/matrix.png";
  import selexfcc from "../images/selexfcc.png";
import selexmsd from "../images/selexmsd.png";
import selexwell from "../images/SelexWell.png";
import selexdot from "../images/selexdot.png";
import selexrxn from "../images/selexrxn.png";
import selexsep from "../images/selexsep.png";
import selexadsorption from "../images/selexad.png";


  import selexmathimg from "../images/SelexSIM.png";
  import SubNavbar from "./CommonC/SubNavbar";
  import { Alert } from "@mui/material";
  import BgContainer2 from "./CommonC/BgContainer2";
  import Grow from '@mui/material/Grow';
  import './YourComponent.css';
  import SelexMathNavbar from "./CommonC/SelexMathNavbar";

  
  const cardStyle = {
  border: "1px solid #0078c9",
  borderRadius: "12px",
  padding: "15px",
  textAlign: "center",
  cursor: "pointer",
  transition: "0.3s",
  "&:hover": {
    transform: "scale(1.05)",
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
  },
};

const imgStyle = {
  height: "60px",
  marginBottom: "10px",
  objectFit: "contain",
};

const labelStyle = {
  fontSize: "13px",
  fontWeight: 500,
};



  
  const SelectSelexMath = ({handleNavigate}) => {
    const navigate = useNavigate();
    const [username, setUsername] = React.useState("");
    const [password, setPassword] = React.useState("");
    const [open, setOpen] = React.useState(false);
    const [activeCard, setActiveCard] = React.useState("math");
    const [hoveredmathmodel, sethoveredmathmodel] = useState(false);
    const [hoveredrom, sethoveredrom] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [openc, setOpenc] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [state, setState] = React.useState({
      isOpen: false,
      vertical: "top",
      horizontal: "center",
    });
    const [checked, setChecked] = React.useState(false);
    const contentMap = {
  math: {
    title: "Mathematical Modeling:",
    desc: `A key component of the SelexSuite by Emad Gebesy, is a state-of-the-art mathematical modeling application designed to address complex engineering challenges in the Oil & Gas and Energy sectors. This powerful tool provides robust capabilities for developing, simulating, and optimizing mathematical models, enabling engineers and researchers to solve intricate problems with precision and efficiency for ODE (Ordinary Differential Equation) and PDE (Partial Differential Equation).
 SelexSIM supports various modeling approaches, including first-principles equations, empirical correlations, and hybrid methods that integrate traditional modeling with machine learning. Its versatile platform allows for seamless integration with simulation tools like Aspen HYSYS, enhancing workflows and enabling accurate predictions of system behavior. With its user-friendly interface and extensive library of advanced algorithms, SelexSIM empowers organizations to accelerate innovation, improve process performance, and make data-driven decisions for sustainability and operational excellence.`,
  },
  lean: {
    title: "Lean Model Dynamics:",
    desc: ` SelexSIM is an advanced feature designed to simplify complex systems into manageable representations while preserving essential dynamics and accuracy. LMD enables engineers to reduce computational loads and enhance simulation speed, making it ideal for real-time analysis, optimization, and control applications. By leveraging techniques like proper orthogonal decomposition (POD) and surrogate modeling, SelexSIM provides efficient solutions for large-scale problems without compromising fidelity, empowering users to achieve faster decision-making and more effective resource allocation.
Discrete and Stochastic Analysis in SelexSIM
SelexSIM offers two powerful analysis methodologies to address diverse engineering challenges:
	•	Discrete Analysis: This approach involves solving deterministic systems where inputs and parameters are fixed and well-defined. It is particularly suited for scenarios requiring precise solutions, such as process optimization, equipment sizing, and steady-state system evaluations.
	•	Stochastic Analysis: This method accounts for uncertainty and variability in system parameters, leveraging probabilistic models to analyze a range of possible outcomes. Stochastic analysis is invaluable for risk assessment, sensitivity studies, and evaluating systems under uncertain conditions, enabling users to develop robust solutions with confidence in real-world applications.`,
  },
  fcc: {
    title: "SelexFCC:",
    desc: `SelexFCC focuses on fluid catalytic cracking simulations, helping optimize
    refinery operations, improve yield, and analyze reaction kinetics efficiently.`,
  },
  msd: {
    title: "SelexMSD:",
    desc: `SelexMSD enables mechanical system design and diagnostics with advanced
    simulation tools, helping engineers improve reliability and performance.`,
  },
};
   
  
    const { vertical, horizontal, isOpen } = state;
  
    const handleOpenc = () => setOpenc(true);
    const handleClosec = () => setOpenc(false);
  
    const handleAuth = async () => {
      setLoading(true);
      const body = {
        username,
        password,
      };
  
      const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      };
      try {
        let result = await fetch(`${baseURL}/login`, options);
        result = await result.json();
        if (result.token) {
          handleNavigate(result.token)
          navigate("/home");
          setLoading(false);
        }
        setLoading(false);
        handleSnackbar(true);
      } catch (error) {
        setLoading(false);
        console.log("error", error);
      }
  
      return;
    };
  
    const handleSnackbar = (value) => {
      setState({ ...state, isOpen: value });
    };

    React.useEffect(() => {
      setChecked(true);
    }, [])
  
   return (
  <Box
    sx={{
      minHeight: "100vh",
      background:
        "linear-gradient(135deg, #f4f9ff 0%, #eef5fb 40%, #ffffff 100%)",
      overflow: "hidden",
      position: "relative",
    }}
  >
    <SelexMathNavbar />
    {/* HERO SECTION */}
    <Box
      sx={{
        width: "92%",
        maxWidth: "1450px",
        margin: "auto",
        pt: 6,
        pb: 8,
      }}
    >
      {/* TOP HEADING */}
      <Box
        sx={{
          textAlign: "center",
          mb: 6,
        }}
      >
       
        <Typography
          sx={{
            fontSize: { xs: 28, md: 34 },
            fontWeight: 700,
        
            WebkitBackgroundClip: "text",
            letterSpacing: "-1px",
            color:"#0078c9"
          }}
        >
           Selex<span style={{ color: "#9e0b22" }}>SIM™</span> Solutions

        </Typography>

        <Typography
          sx={{
            fontSize: 17,
            color: "#64748b",
            mt: 1.5,
            maxWidth: "780px",
            margin: "auto",
            lineHeight: 1.7,
          }}
        >
          Explore powerful engineering and simulation platforms
          designed for mathematical modeling, optimization,
          kinetics, process simulation and advanced analysis.
        </Typography>
      </Box>

      {/* SOLUTIONS GRID */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "1fr 1fr",
            md: "repeat(3, 1fr)",
            lg: "repeat(4, 1fr)",
          },
          gap: 3,
        }}
      >
        {/* CARD 1 */}
        <Box
          onClick={() => navigate("/selexsim")}
          sx={{
            cursor: "pointer",
            borderRadius: "28px",
            p: 4,
            background:
              "linear-gradient(135deg, rgba(255,255,255,0.95), rgba(240,247,255,0.92))",
            border: "1px solid #dbeafe",
            backdropFilter: "blur(12px)",
            boxShadow: "0 12px 35px rgba(0,0,0,0.06)",
            transition: "0.35s",
            "&:hover": {
              transform: "translateY(-8px)",
              boxShadow: "0 18px 45px rgba(0,120,201,0.18)",
              border: "1px solid #0078c9",
            },
          }}
        >
          <Box
            sx={{
              width: 78,
              height: 78,
              borderRadius: "22px",
              background:
                "linear-gradient(135deg, #e0f2fe 0%, #dbeafe 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 3,
            }}
          >
            <img
              src={Selexlogo}
              alt=""
              style={{
                width: "52px",
              }}
            />
          </Box>

          <Typography
            sx={{
              fontSize: 22,
              fontWeight: 700,
              color: "#0f172a",
              mb: 1,
            }}
          >
            SelexMath™
          </Typography>

          <Typography
            sx={{
              fontSize: 14,
              color: "#64748b",
              lineHeight: 1.8,
            }}
          >
            Build dynamic mathematical models, perform
            simulations and solve engineering systems with
            advanced computational tools.
          </Typography>
        </Box>

        {/* CARD 2 */}
        <Box
          onClick={() => navigate("/selexanalysis")}
          sx={{
            cursor: "pointer",
            borderRadius: "28px",
            p: 4,
            background:
              "linear-gradient(135deg, rgba(255,255,255,0.95), rgba(240,247,255,0.92))",
            border: "1px solid #dbeafe",
            backdropFilter: "blur(12px)",
            boxShadow: "0 12px 35px rgba(0,0,0,0.06)",
            transition: "0.35s",
            "&:hover": {
              transform: "translateY(-8px)",
              boxShadow: "0 18px 45px rgba(0,120,201,0.18)",
              border: "1px solid #0078c9",
            },
          }}
        >
          <Box
            sx={{
              width: 78,
              height: 78,
              borderRadius: "22px",
              background:
                "linear-gradient(135deg, #ecfeff 0%, #dbeafe 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 3,
            }}
          >
            <img
              src={matrix}
              alt=""
              style={{
                width: "52px",
              }}
            />
          </Box>

          <Typography
            sx={{
              fontSize: 22,
              fontWeight: 700,
              color: "#0f172a",
              mb: 1,
            }}
          >
            SelexLMD™
          </Typography>

          <Typography
            sx={{
              fontSize: 14,
              color: "#64748b",
              lineHeight: 1.8,
            }}
          >
            Analyze process dynamics, optimize operational
            efficiency and visualize performance trends through
            intelligent simulations.
          </Typography>
        </Box>

        {/* CARD 3 */}
        <Box
          onClick={() => navigate("/selexfcc")}
          sx={{
            cursor: "pointer",
            borderRadius: "28px",
            p: 4,
            background:
              "linear-gradient(135deg, rgba(255,255,255,0.95), rgba(240,247,255,0.92))",
            border: "1px solid #dbeafe",
            backdropFilter: "blur(12px)",
            boxShadow: "0 12px 35px rgba(0,0,0,0.06)",
            transition: "0.35s",
            "&:hover": {
              transform: "translateY(-8px)",
              boxShadow: "0 18px 45px rgba(0,120,201,0.18)",
              border: "1px solid #0078c9",
            },
          }}
        >
          <Box
            sx={{
              width: 78,
              height: 78,
              borderRadius: "22px",
              background:
                "linear-gradient(135deg, #eff6ff 0%, #e0e7ff 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 3,
            }}
          >
            <img
              src={selexfcc}
              alt=""
              style={{
                width: "52px",
              }}
            />
          </Box>

          <Typography
            sx={{
              fontSize: 22,
              fontWeight: 700,
              color: "#0f172a",
              mb: 1,
            }}
          >
            SelexFCC™
          </Typography>

          <Typography
            sx={{
              fontSize: 14,
              color: "#64748b",
              lineHeight: 1.8,
            }}
          >
            Simulate fluid catalytic cracking systems, optimize
            refinery operations and improve reaction yield
            efficiency.
          </Typography>
        </Box>

        {/* CARD 4 */}
        <Box
          onClick={() => navigate("/selexmsd")}
          sx={{
            cursor: "pointer",
            borderRadius: "28px",
            p: 4,
            background:
              "linear-gradient(135deg, rgba(255,255,255,0.95), rgba(240,247,255,0.92))",
            border: "1px solid #dbeafe",
            backdropFilter: "blur(12px)",
            boxShadow: "0 12px 35px rgba(0,0,0,0.06)",
            transition: "0.35s",
            "&:hover": {
              transform: "translateY(-8px)",
              boxShadow: "0 18px 45px rgba(0,120,201,0.18)",
              border: "1px solid #0078c9",
            },
          }}
        >
          <Box
            sx={{
              width: 78,
              height: 78,
              borderRadius: "22px",
              background:
                "linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 3,
            }}
          >
            <img
              src={selexmsd}
              alt=""
              style={{
                width: "52px",
              }}
            />
          </Box>

          <Typography
            sx={{
              fontSize: 22,
              fontWeight: 700,
              color: "#0f172a",
              mb: 1,
            }}
          >
            SelexMSD™
          </Typography>

          <Typography
            sx={{
              fontSize: 14,
              color: "#64748b",
              lineHeight: 1.8,
            }}
          >
            Perform model synthesis and simulation-driven
            decision analysis for advanced industrial systems.
          </Typography>
        </Box>

        {/* ADD REMAINING 3 SOFTWARES SAME STYLE */}
         <Box
          onClick={() => navigate("#")}
          sx={{
            cursor: "pointer",
            borderRadius: "28px",
            p: 4,
            background:
              "linear-gradient(135deg, rgba(255,255,255,0.95), rgba(240,247,255,0.92))",
            border: "1px solid #dbeafe",
            backdropFilter: "blur(12px)",
            boxShadow: "0 12px 35px rgba(0,0,0,0.06)",
            transition: "0.35s",
            "&:hover": {
              transform: "translateY(-8px)",
              boxShadow: "0 18px 45px rgba(0,120,201,0.18)",
              border: "1px solid #0078c9",
            },
          }}
        >
          <Box
            sx={{
              width: 78,
              height: 78,
              borderRadius: "22px",
              background:
                "linear-gradient(135deg, #ecfeff 0%, #dbeafe 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 3,
            }}
          >
            <img
              src={selexwell}
              alt=""
              style={{
                width: "52px",
              }}
            />
          </Box>

          <Typography
            sx={{
              fontSize: 22,
              fontWeight: 700,
              color: "#0f172a",
              mb: 1,
            }}
          >
            SelexWell™
          </Typography>

          <Typography
            sx={{
              fontSize: 14,
              color: "#64748b",
              lineHeight: 1.8,
            }}
          >
            Utilizing the physics along with the multilinear
regression, SelexWELL™ generates big data for wellhead
monitoring and VFM.
          </Typography>
        </Box>
         <Box
          onClick={() => navigate("#")}
          sx={{
            cursor: "pointer",
            borderRadius: "28px",
            p: 4,
            background:
              "linear-gradient(135deg, rgba(255,255,255,0.95), rgba(240,247,255,0.92))",
            border: "1px solid #dbeafe",
            backdropFilter: "blur(12px)",
            boxShadow: "0 12px 35px rgba(0,0,0,0.06)",
            transition: "0.35s",
            "&:hover": {
              transform: "translateY(-8px)",
              boxShadow: "0 18px 45px rgba(0,120,201,0.18)",
              border: "1px solid #0078c9",
            },
          }}
        >
          <Box
            sx={{
              width: 78,
              height: 78,
              borderRadius: "22px",
              background:
                "linear-gradient(135deg, #ecfeff 0%, #dbeafe 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 3,
            }}
          >
            <img
              src={selexdot}
              alt=""
              style={{
                width: "52px",
              }}
            />
          </Box>

          <Typography
            sx={{
              fontSize: 22,
              fontWeight: 700,
              color: "#0f172a",
              mb: 1,
            }}
          >
            SelexDOT™
          </Typography>

          <Typography
            sx={{
              fontSize: 14,
              color: "#64748b",
              lineHeight: 1.8,
            }}
          >
            Cutting-edge technology of SelexDOT™ leveraging the
plant data to generate AI models layered with an
optimization engine to dynamically optimize the
operation.
          </Typography>
        </Box>

         <Box
          onClick={() => navigate("#")}
          sx={{
            cursor: "pointer",
            borderRadius: "28px",
            p: 4,
            background:
              "linear-gradient(135deg, rgba(255,255,255,0.95), rgba(240,247,255,0.92))",
            border: "1px solid #dbeafe",
            backdropFilter: "blur(12px)",
            boxShadow: "0 12px 35px rgba(0,0,0,0.06)",
            transition: "0.35s",
            "&:hover": {
              transform: "translateY(-8px)",
              boxShadow: "0 18px 45px rgba(0,120,201,0.18)",
              border: "1px solid #0078c9",
            },
          }}
        >
          <Box
            sx={{
              width: 78,
              height: 78,
              borderRadius: "22px",
              background:
                "linear-gradient(135deg, #ecfeff 0%, #dbeafe 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 3,
            }}
          >
            <img
              src={selexrxn}
              alt=""
              style={{
                width: "52px",
              }}
            />
          </Box>

          <Typography
            sx={{
              fontSize: 22,
              fontWeight: 700,
              color: "#0f172a",
              mb: 1,
            }}
          >
            SelexRXN™
          </Typography>

          <Typography
            sx={{
              fontSize: 14,
              color: "#64748b",
              lineHeight: 1.8,
            }}
          >
           SelexRXN™ Utilizing the field data and catalyst properties,
this module helps operation to relate the catalyst
efficiency (health) with respect to the time
          </Typography>
        </Box>

<Box
          onClick={() => navigate("#")}
          sx={{
            cursor: "pointer",
            borderRadius: "28px",
            p: 4,
            background:
              "linear-gradient(135deg, rgba(255,255,255,0.95), rgba(240,247,255,0.92))",
            border: "1px solid #dbeafe",
            backdropFilter: "blur(12px)",
            boxShadow: "0 12px 35px rgba(0,0,0,0.06)",
            transition: "0.35s",
            "&:hover": {
              transform: "translateY(-8px)",
              boxShadow: "0 18px 45px rgba(0,120,201,0.18)",
              border: "1px solid #0078c9",
            },
          }}
        >
          <Box
            sx={{
              width: 78,
              height: 78,
              borderRadius: "22px",
              background:
                "linear-gradient(135deg, #ecfeff 0%, #dbeafe 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 3,
            }}
          >
            <img
              src={selexsep}
              alt=""
              style={{
                width: "52px",
              }}
            />
          </Box>

          <Typography
            sx={{
              fontSize: 22,
              fontWeight: 700,
              color: "#0f172a",
              mb: 1,
            }}
          >
            SelexSEP™
                      </Typography>

          <Typography
            sx={{
              fontSize: 14,
              color: "#64748b",
              lineHeight: 1.8,
            }}
          >
            SelexSEP™ is a Powerful AI-based tool to predict the
Liquid Carryover and PTB from Desalter
          </Typography>
        </Box>


        <Box
          onClick={() => navigate("#")}
          sx={{
            cursor: "pointer",
            borderRadius: "28px",
            p: 4,
            background:
              "linear-gradient(135deg, rgba(255,255,255,0.95), rgba(240,247,255,0.92))",
            border: "1px solid #dbeafe",
            backdropFilter: "blur(12px)",
            boxShadow: "0 12px 35px rgba(0,0,0,0.06)",
            transition: "0.35s",
            "&:hover": {
              transform: "translateY(-8px)",
              boxShadow: "0 18px 45px rgba(0,120,201,0.18)",
              border: "1px solid #0078c9",
            },
          }}
        >
          <Box
            sx={{
              width: 78,
              height: 78,
              borderRadius: "22px",
              background:
                "linear-gradient(135deg, #ecfeff 0%, #dbeafe 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 3,
            }}
          >
            <img
              src={selexadsorption}
              alt=""
              style={{
                width: "52px",
              }}
            />
          </Box>

          <Typography
            sx={{
              fontSize: 22,
              fontWeight: 700,
              color: "#0f172a",
              mb: 1,
            }}
          >
            SelexAdsorption™
                      </Typography>

          <Typography
            sx={{
              fontSize: 14,
              color: "#64748b",
              lineHeight: 1.8,
            }}
          >
            SelexAdsorption™
is a surrogate
model for AI
Inferential​
          </Typography>
        </Box>
        
      </Box>
    </Box>
  </Box>
);
  };
  
  export default SelectSelexMath;
  